import { render, staticRenderFns } from "./GeneralTermsOfSale.vue?vue&type=template&id=3d3c9697&"
import script from "./GeneralTermsOfSale.vue?vue&type=script&lang=js&"
export * from "./GeneralTermsOfSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports